
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.72 6.96a.75.75 0 00-1.28-.53l-5.36 4a1.75 1.75 0 102.38 2.4l4.04-5.34a.75.75 0 00.22-.53z"}}),_c('path',{attrs:{"d":"M12 24a12 12 0 1112-12 12.01 12.01 0 01-12 12zm0-23a11 11 0 1011 11A11.01 11.01 0 0012 1z"}}),_c('path',{attrs:{"d":"M16.88 17.42a.5.5 0 01-.36-.86 6.45 6.45 0 001.94-4.62 6.51 6.51 0 00-.78-3.1.5.5 0 01.88-.48 7.5 7.5 0 01-1.33 8.92.5.5 0 01-.36.14zm-9.83 0a.5.5 0 01-.36-.15 7.5 7.5 0 015.27-12.83 7.54 7.54 0 013.62.92.5.5 0 01-.48.88 6.5 6.5 0 00-9.64 5.7 6.45 6.45 0 001.94 4.62.5.5 0 01-.35.86z"}})])
          )
        }
      }
    